import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { DeviceDetectorProvider } from '@monorepo/device-detector';
import { NotificationProvider } from '@monorepo/notification';
import { SiteSettingsProvider } from '@monorepo/site-settings';
import { RequestsProvider, TRequestsMap } from '@monorepo/requests';
import useRequestPermission from '../../hooks/useRequestPermission';



type Props = {
  requestsMap: TRequestsMap;
  siteSettings: any;
};

const App: Component<Props> = ({ requestsMap, siteSettings, children }) => {
  // const { firabasePermission } = useRequestPermission();
  //
  // useEffect(() => {
  //   firabasePermission();
  // }, []);

  return (
      <DeviceDetectorProvider>
        <NotificationProvider>
          <RequestsProvider requestsMap={requestsMap}>
            <SiteSettingsProvider siteSettings={siteSettings}>
              <ReactQueryDevtools initialIsOpen={true} />
              <BrowserRouter>{children}</BrowserRouter>
            </SiteSettingsProvider>
          </RequestsProvider>
        </NotificationProvider>
      </DeviceDetectorProvider>
  );
};

export default App;
